import { createRequest, getEndpoint } from "../requestCreator";

export const getGenerateExportData = createRequest(getEndpoint("export.sub.generate"));

export const getExportedCsv = createRequest(getEndpoint("export.sub.download"), {
  fileRequest: true,
});
